import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ApprovedSuggest.css";
import { useNavigate } from "react-router-dom";

export default function ApprovedSuggest() {
  const [suggestions, setSuggestions] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchApprovedSuggestions = async () => {
      try {
        const response = await fetch(
          "https://cemetery-management.vercel.app/api/suggestion/approved"
        );
        const data = await response.json();
        setSuggestions(data);
      } catch (error) {
        console.error("حدث خطأ أثناء جلب الاقتراحات المقبولة:", error);
      }
    };

    fetchApprovedSuggestions();
  }, []);

  const handleNavigateToSuggest = () => {
    navigate("/suggest");
  };

  return (
    <div className="container">
      <h2 className="my-4 text-center sug-head">إقترحات أهالي الشوبك الغربي</h2>
      {suggestions.length > 0 ? (
        <div className="suggest-content container">
          {/* <div className="suggest-heading">
            <div>
              <p>الإسم</p>
              <p>الاقتراح</p>
              <p>الحالة</p>
            </div>
          </div> */}
          <div>
            {suggestions.map((suggestion, index) => (
              <div className="suggest-info" key={suggestion._id}>
                {/* <td>{index + 1}</td> */}
                <p>
                  <span>{suggestion.name}</span>
                </p>
                <p>{suggestion.text}</p>
              </div>
            ))}
          </div>
          <div className=" mt-4">
            <button
              className="btn btn-primary"
              onClick={handleNavigateToSuggest}
            >
              اقتراحك
            </button>
          </div>
        </div>
      ) : (
        <p className="text-center">لا توجد اقتراحات.</p>
      )}
    </div>
  );
}
